import { render, staticRenderFns } from "./CouponView.vue?vue&type=template&id=6874a743&"
import script from "./CouponView.vue?vue&type=script&lang=js&"
export * from "./CouponView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports